import PropTypes from "prop-types";
import React from "react";
import { MdStar } from "react-icons/md";

function Stars({ count }) {
  return (
    <div className="mobilityMutual__stars">
      {Array.from({ length: count }).map((_, index) => (
        <MdStar key={index} size={20} />
      ))}
    </div>
  );
}

Stars.propTypes = {
  count: PropTypes.number.isRequired,
};

export default React.memo(Stars);
